// Experiments persist only here: the server keeps results for 1 hour.
const DB_NAME = "oko-lesson-report-console";
const STORE = "experiments";

let dbPromise;
const db = () => {
  dbPromise = dbPromise || new Promise((resolve, reject) => {
    const open = indexedDB.open(DB_NAME, 1);
    open.onupgradeneeded = () => open.result.createObjectStore(STORE, { keyPath: "id" });
    open.onsuccess = () => resolve(open.result);
    open.onerror = () => {
      dbPromise = null;
      reject(open.error);
    };
  });
  return dbPromise;
};

// Settles on the transaction, not the request: a write that fails to commit
// (e.g. quota) aborts the transaction after its request already succeeded.
const tx = async (mode, fn) => {
  const transaction = (await db()).transaction(STORE, mode);
  return new Promise((resolve, reject) => {
    const req = fn(transaction.objectStore(STORE));
    transaction.oncomplete = () => resolve(req.result);
    transaction.onabort = () => reject(transaction.error || req.error);
    transaction.onerror = () => reject(transaction.error || req.error);
  });
};

export const saveExperiment = (experiment) =>
  tx("readwrite", (s) => s.put({ ...experiment, updated_at: new Date().toISOString() }));
export const listExperiments = () => tx("readonly", (s) => s.getAll());
export const deleteExperiment = (id) => tx("readwrite", (s) => s.delete(id));
